import { render, staticRenderFns } from "./PropertyViewer.vue?vue&type=template&id=716b73d6&"
import script from "./PropertyViewer.vue?vue&type=script&lang=ts&"
export * from "./PropertyViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports